<google-map
    width="100%"
    height="100%"
    [center]="center"
    [options]="options"
    >
</google-map>
